const BASE = (import.meta.env.VITE_API_BASE_URL ?? '').replace(/\/$/, '');

let session: string | null = null;
export function setSession(s: string | null) {
  session = s;
  if (s) sessionStorage.setItem('ba_session', s);
  else sessionStorage.removeItem('ba_session');
}
export function loadSession(): string | null {
  if (session) return session;
  session = sessionStorage.getItem('ba_session');
  return session;
}

async function req<T>(path: string, init: RequestInit = {}): Promise<T> {
  const headers = new Headers(init.headers);
  headers.set('Content-Type', 'application/json');
  const s = loadSession();
  if (s) headers.set('Authorization', `Bearer ${s}`);
  const res = await fetch(`${BASE}${path}`, { ...init, headers });
  if (!res.ok) {
    const text = await res.text();
    throw new Error(`API ${res.status}: ${text}`);
  }
  return (await res.json()) as T;
}

export type Rank = 'standard' | 'high_class' | 'platinum';
export type MemberStatus = 'pending' | 'active' | 'past_due' | 'canceled' | 'invited';

export type AuthResponse = {
  session: string;
  member: { id: string; displayName: string | null; rank: Rank; status: MemberStatus };
};

export type Membership = {
  id: string;
  displayName: string | null;
  rank: Rank;
  status: MemberStatus;
  joinedAt: string | null;
  subscription: {
    status: string | null;
    priceId: string | null;
    currentPeriodEnd: string | null;
  } | null;
};

export const api = {
  authLine: (idToken: string) =>
    req<AuthResponse>('/api/auth/line', { method: 'POST', body: JSON.stringify({ idToken }) }),
  membership: () => req<Membership>('/api/membership'),
  checkout: (rank: Rank, returnUrl: string) =>
    req<{ url: string }>('/api/checkout', {
      method: 'POST',
      body: JSON.stringify({ rank, returnUrl }),
    }),
  portal: (returnUrl: string) =>
    req<{ url: string }>('/api/portal', { method: 'POST', body: JSON.stringify({ returnUrl }) }),
  qr: () => req<{ token: string; expiresInSec: number }>('/api/qr'),
};
